import { useState, useEffect, useMemo } from 'react';
import {
    Row, Col, Table, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter,
    Button, Label, Input, Form, FormGroup, Spinner, CardHeader
} from 'reactstrap';
import { FaChevronRight, FaChevronLeft, FaPlus } from 'react-icons/fa';
import './Lmu.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import uuid from 'react-uuid';
import LmuItem from './LmuItem';
import BiodiversityForm from './BiodiversityForm';
import InherentRisks from './InherentRisks';
import AdditionalInformation from './AdditionalInformation';
import EnterpriseDetailForm from './EnterpriseDetailForm';
import NonContiguousForm from './NonContiguousForm';
import GeneralDetailForm from './GeneralDetailForm';
import ActionsToConsider from '../FarmApt/ActionsToConsider';
import Action from '../Action/Action';
import Risk from '../ItemPopup/Risk';
import MapView from '../Map/MapView';
import Photos from '../Uploads/Photos';
import FurtherDetailForm from './FurtherDetailForm';
import MaintenancePlan from '../MaintenancePlan/MaintenancePlan';
import Validate from '../Validate/Validate';
import ToggleSwitch from '../ThreeStateToggle/ToggleSwitch';
import { useNavigate, useLocation } from "react-router-dom";
import Documents from '../Uploads/Documents';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import PhotosWithoutId from '../Uploads/PhotosWithoutId';
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const Lmu = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage, refreshToken }) => {

    const [additionalInfoIsOpen, setAdditionalInfoIsOpen] = useState(false);
    const [additionalInfoIsIconUp, setAdditionalInfoIsIconUp] = useState(false);

    const additionalInfoToggle = () => {
        setAdditionalInfoIsOpen(!additionalInfoIsOpen)
        setAdditionalInfoIsIconUp(!additionalInfoIsIconUp)
    };

    const [enterpriseIsOpen, setEnterpriseIsOpen] = useState(false);
    const [enterpriseIsIconUp, setEnterpriseIsIconUp] = useState(false);

    const enterpriseToggle = () => {
        setEnterpriseIsOpen(!enterpriseIsOpen)
        setEnterpriseIsIconUp(!enterpriseIsIconUp)
    };

    const [roleName, setRoleName] = useState(localStorage.getItem("roleName")); const [imageUploadList, setImageUploadList] = useState([]);
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    /*const isAddArchiveItem = localStorage.getItem("isAddArchiveItem"); */
    const [farmId] = useState(localStorage.getItem("defaultFarmId")); const [toggleSwitch, setToggleSwitch] = useState('map & details');
    const [userId] = useState(localStorage.getItem("loggedInUserId")); const [saving, setSaving] = useState('');
    const { state } = useLocation();
    const navigate = useNavigate(); const [lmuItems, setLMUItems] = useState([]);
    const [lmu, setLmu] = useState({ outlineList: [], itemList: [], itemTypes: [], section: 'Lmu', sectionName: 'Land Units (LU\'s)', isWizardCompleted: false, lookUpList : [] });
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false,
        isLMUPage: true,
        isCenterReq: false,
        isFarmCenterEditable: false,
        isFarmOutlineEditable: false,
        zoomLevel: 15,
        polyType: '',
        itemsEditable: false,
        highlighteditemId: 0,
        isHiglighted: false, isClear: false, showLabel: false,
        joinNCLUs : false
    });
    const [inherentRisksTempList1, setInherentRisksTempList1] = useState([]);
    const [itemsList, setItemsList] = useState([]);
    const [masterLmuList, setMasterLmuList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [typeId, setTypeId] = useState(0);
    const [isClosedActionShow, setIsClosedActionShow] = useState(false);
    const [isNonContiguous, setIsNonContiguous] = useState(false);
    const [hasBiodiversity, setHasBiodiversity] = useState(false);
    const [isNonEffective, setIsNonEffective] = useState(false);
    const [blockSummary, setBlockSummary] = useState({ total: 0, effective: 0, totalArea: 0.0, totalEffectiveArea: 0.0 });
    const [itemMapDetail, setItemMapDetail] = useState({ markerType: '', area: 0.0, perimeter: 0.0, coordinates: '', });
    const [itemModal, setItemModal] = useState({ showItemModal: false, itemId: 0, item: [], action: '' });
    const [actionModal, setActionModal] = useState({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [itemDeleteModal, setItemDeleteModal] = useState({ showModal: false, itemId: 0 });
    const [formGeneral, setFormGeneral] = useState({
        itemId: 0,
        LmuTypeId: 0,
        Name: '',
        Description: '',
        itemColour: '',
        itemSizeHa: 0.0,
        isEdited: false
    });
    const [formContiguous, setFormContiguous] = useState({ itemId: 0, isNonContiguousItem: false, masterLmuId: 0, isSameAsMaster : false });
    const [formDescription, setFormDescription] = useState({ isBiodiversityReq: false, itemId: 0, isAddsToBiodiversity: false, biodiversityComment: '' });
    const [formBasicDetail, setFormBasicDetail] = useState({
        itemId: 0,
        isNonEffectiveArea: false,
        effectiveArea: 0.0,
        isLeasedBlock: false,
        leasedAreaHa: 0.0,
        isReceivesLiquidEffluent: false,
        isReceivesFreshWaterIrrigation: false,
        stemCountPerHa: 0.0,
        topographyId: 0,
        soilTypePredominantId: 0,
        soilTypePredominantPercentage: 0.0,
        soilTypeOtherId: 0,
        soilTypeOtherPercentage: 0.0,
        drainabilityPredominant: 0,
        drainabilityOther: 0,
        inherentRisks: '',
        topographyList: [],
        soilTypePredominantList: [],
        soilTypeOtherList: [],
        drainabilityPredominantList: [],
        drainabilityOtherList: [],
        inherentRisksList: []
    });  
    const [formRisk, setFormRisk] = useState({ isRisk: 'No', riskComment: '', isMitigated: false, mitigatedComment: '' });
    const [formEnterpriseDetail, setFormEnterpriseDetail] = useState({
        itemId: 0,
        enterpriseType: '',
        enterpriseDefinition: 0,
        generalFarmingActivities: '',
        enterpriseTypeList: [],
        enterpriseDefinitionList: [],
        IsLUDoesNotHaveAnyFarmingOrGrowingActivities: false, FrostProtection: false, ShowFrostProtection: false
    });
    const [formPastureDrainage, setFormPastureDrainage] = useState({
        dominantPastureSpecies: 0,
        pastureBlockProductivityPercentage: 0.0,
        isArtificiallyDrained: true,
        artificiallyDrainedPercentage: 0.0,
        artificialDrainageType: 0,
        susceptibilityToPugging: 0,
        irrigationScheduled: 0,
        dominantPastureSpeciesList: [],
        artificialDrainageTypeList: [],
        susceptibilityToPuggingList: [],
        irrigationScheduledList: [],
    });
    const [formSoil, setFormSoil] = useState({
        lmuId: 0,
        soilDetail: [],
        soilMapGroupsList: [],
        soilMapOrdersList: [],
    })
    const [blockOnly, setBlockOnly] = useState({
        defaultZoomLevel: 15,
        isViewBlockOnly: false,
        name: '',
        itemId: 0,
        coordinates: '',
        showCenterPinPopup: false,
        actionType: '',
        zoomLevelList: [],
        islargeEnterprise: false
    })
    const [formStrengths, setFormStrengths] = useState({
        lmuId: 0,
        strengths: [],
        strengthsDetailList: [],
    })
    const [formWeaknesses, setFormWeaknesses] = useState({
        lmuId: 0,
        weaknesses: [],
        weaknessesDetailList: [],
    })
    const [sectionObj, setSectionObj] = useState({});
    const [toggleItemState, setToggleItemState] = useState({ lmuId: 0, isOpen: false, isIconUp: false });
    const [toggleChildItemState, setToggleChildItemState] = useState({ lmuId: 0, isOpen: false, isIconUp: false });
    const [hideChildren, setHideChildren] = useState({ lmuId: 0, childLUDisplay: 0, ishideChildren: true });
    const [gisLayerTopographyDetails, setGISLayerTopographyDetails] = useState({ showGISLayer: false, gisLayerList: [] })
    const [gisLayerSoilDetails, setGISLayerSoilDetails] = useState({ showGISLayer: false, gisLayerList: [] })
    const [gisLayerWetlandDetails, setGISLayerWetlandDetails] = useState({ showGISLayer: false, gisLayerList: [] })
    const [multiItemModal, setMultiItemModal] = useState({ showMultiItemModal: false, itemList: [] });

    useEffect(() => {
        setLoading(true);
        getLmu();
        const auth = localStorage.getItem("auth");
    }, [])



    const getLmu = async () => {

        try {
            const response = await apiGet(
                '/api/lmu/getLmu/', {
                params: {
                    farmId: farmId
                }
            });

            const itemsList = response.data.itemsList;
            setLMUItems(itemsList);
            itemsList.forEach((item) => {
                item.nonContiguousItems = [];

                itemsList.map(nc => {
                    if (nc.lmuId === item.id) {
                        item.nonContiguousItems.push(nc);
                    }
                })

            })

            const lmuList = itemsList.map(item => item.lmuItems[0])
            const effectiveLmuList = lmuList.filter(item => !item.isNonEffectiveArea)
            let effectiveAreaTotal = 0;
            let totalArea = 0;

            lmuList.forEach(lmu => {
                totalArea += lmu.sizeHa;
            })

            effectiveLmuList.forEach(lmu => {
                effectiveAreaTotal += lmu.effectiveAreaHa > 0 ? lmu.effectiveAreaHa : lmu.sizeHa;
            })

            setMasterLmuList(response.data.lookUpList.masterLmuList);

            setBlockSummary({ total: lmuList.length, effective: effectiveLmuList.length, totalArea: totalArea, totalEffectiveArea: effectiveAreaTotal })

            setLmu({ ...lmu, outlineList: response.data.outline, itemList: itemsList, itemTypes: response.data.itemTypeList, isWizardCompleted: response.data.isFWFPCompleted, lookUpList: response.data.lookUpList });

            setItemsList(itemsList);

            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel, polyType: '' });
            setLoading(false);
            setSectionObj(response.data.section);
            setBlockOnly({ ...blockOnly, zoomLevelList: response.data.zoomLeveList, showCenterPinPopup: false, name: '', islargeEnterprise: response.data.islargeEnterprise })
            setGISLayerTopographyDetails({ ...gisLayerTopographyDetails, gisLayerList: response.data.gisLayerList_TopographyMap });
            setGISLayerSoilDetails({ ...gisLayerSoilDetails, gisLayerList: response.data.gisLayerList_SoilMap });
            setGISLayerWetlandDetails({ ...gisLayerWetlandDetails, gisLayerList: response.data.gisLayerList_WetlandMap });
            setInherentRisksTempList1(response.data.lookUpList.inherentVulnerabilityList)
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                if (section.length > 0 != null) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            if (state != null) {
                const { itemId, actionId, navigateFrom } = state;
                navigate(state.pathname, { replace: true });
                if (navigateFrom == "Actions") {
                    handleNavigateOpenActionPopup(itemId, actionId, itemsList);
                }
                else {
                    editMapItemFromNavigation(itemId, itemsList, response.data)
                }
            }

        } catch (err) {
            console.log(err);
        }
    }

    const resetItemModal = () => {
        setIsNonContiguous(false);
        setHasBiodiversity(false);
        setFormContiguous({ itemId: 0, isNonContiguousItem: false, masterLmuId: 0, isSameAsMaster: false });
        setFormDescription({ isBiodiversityReq: false, itemId: 0, isAddsToBiodiversity: false, biodiversityComment: '' });
        setFormBasicDetail({
            itemId: 0,
            isReceivesLiquidEffluent: false,
            isReceivesFreshWaterIrrigation: false,
            stemCountPerHa: 0.0,
            topographyId: 0,
            soilTypePredominantId: 0,
            soilTypePredominantPercentage: 0.0,
            soilTypeOtherId: 0,
            soilTypeOtherPercentage: 0.0,
            inherentRisks: '',
            isLeasedBlock: false,
            leasedAreaHa : 0.0,
            topographyList: lmu.lookUpList.topographyList,
            soilTypePredominantList: lmu.lookUpList.soilTypePredominantList,
            soilTypeOtherList: lmu.lookUpList.soilTypeOtherList,
            drainabilityPredominantList: lmu.lookUpList.drainabilityPredominantList,
            drainabilityOtherList: lmu.lookUpList.drainabilityOtherList,
            inherentRisksList: lmu.lookUpList.inherentVulnerabilityList
        });
        setFormEnterpriseDetail({
            itemId: 0,
            enterpriseType: '',
            enterpriseDefinition: 0,
            generalFarmingActivities: '',
            enterpriseTypeList: lmu.lookUpList.enterpriseTypeList,
            enterpriseDefinitionList: lmu.lookUpList.enterpriseDefinitionList,
            IsLUDoesNotHaveAnyFarmingOrGrowingActivities: false, FrostProtection:false
        });
        setFormPastureDrainage({
            dominantPastureSpecies: 0,
            pastureBlockProductivityPercentage: 0.0,
            isArtificiallyDrained: true,
            artificiallyDrainedPercentage: 0.0,
            artificialDrainageType: 0,
            susceptibilityToPugging: 0,
            irrigationScheduled: 0,
            dominantPastureSpeciesList: lmu.lookUpList.dominantPastureSpeciesList,
            artificialDrainageTypeList: lmu.lookUpList.artificialDrainageTypeList,
            susceptibilityToPuggingList: lmu.lookUpList.susceptibilityToPuggingList,
            irrigationScheduledList: lmu.lookUpList.irrigationScheduledList,
        })
        setFormRisk({
            isRisk: 'No',
            riskComment: '',
            isMitigated: false,
            mitigatedComment: ''
        });
        setFormSoil({
            lmuId: 0,
            soilDetail: [],
            soilMapGroupsList: lmu.lookUpList.soilMapGroupsList,
            soilMapOrdersList: lmu.lookUpList.soilMapOrdersList,
        })
        setFormStrengths({
            lmuId: 0,
            strengths: [],
            strengthsDetailList: lmu.lookUpList.lmuStrengthsList,
        })
        setFormWeaknesses({
            lmuId: 0,
            weaknesses: [],
            weaknessesDetailList: lmu.lookUpList.lmuWeaknessesList,
        })
    }

    const addMapItem = (mapItem, mapType) => {

        resetItemModal();

        let path,
            area = 0.0,
            perimeter = 0.0,
            coordinates = '',
            polygonCoordinates = '';

        if (mapType == 'polygon') {

            setItemModal({ ...itemModal, showItemModal: true, itemId: 0, item: [], action: 'Added' });

            setIsNonEffective(false);

            if (mapType == 'polygon') {
                path = mapItem.getPath();
                area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);

                path.getArray().map((c) => {

                    polygonCoordinates = polygonCoordinates + c.toString().replace('(', '').replace(')', '') + ":";
                })

                coordinates = polygonCoordinates;
            }

            setFormGeneral({
                itemId: 0,
                LmuTypeId: 0,
                Name: '',
                Description: '',
                itemColour: '#41533d',
                itemSizeHa: area,
                isEdited: false
            })

            setItemMapDetail({ markerType: mapType, area: area, perimeter: perimeter, coordinates: coordinates });
        }
        else {
            //Block centre pin
            const item = itemsList.filter(item => item.id == blockOnly.itemId)[0];

            coordinates = mapItem.getPosition().lat().toFixed(6) + ", " + mapItem.getPosition().lng().toFixed(6);
            setBlockOnly({ ...blockOnly, name: item.name + ' - Centre Pin', coordinates: coordinates, showCenterPinPopup: true, actionType: 'Add New' })
        }
    }

    const handleMapItemEdited = (itemId, type, strValue) => {
        let name = '';
        let value = '';

        if (type == "polygonBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }
        const itemListTemp = itemsList.map(item =>
            item.id === itemId
                ? { ...item, [name]: value, isEdited: true }
                : item
        )
        setLmu({ ...lmu, itemList: itemListTemp });

    }

    const editMapItem = (mapItem, itemId, isDragged) => {

        const item = itemsList.filter(item => item.id == itemId)[0];
        const itemTemp = lmu.itemList.filter(item => item.id == itemId)[0];
        const lmuItem = item?.lmuItems[0];
        const isNonContiguousItem = item.isConnectedToAnotherLMU == null || item.isConnectedToAnotherLMU == false || item.isConnectedToAnotherLMU == undefined ? false : true
        const isSameAsMaster = lmuItem.isSameAsMaster == null || lmuItem.isSameAsMaster == false || lmuItem.isSameAsMaster == undefined ? false : true
        const isNonEffectiveArea = lmuItem.isNonEffectiveArea == null || lmuItem.isNonEffectiveArea == false || lmuItem.isNonEffectiveArea == undefined ? false : true
        const hasBiodiversity = item.isAddsToBiodiversity == null || item.isAddsToBiodiversity == false || item.isAddsToBiodiversity == undefined ? false : true
        const isBiodiversityReq = hasBiodiversity ? lmu.itemTypes.filter(type => type.id == item.itemTypeId)[0].isBiodiversityReq == true ? true : false : false;

        setTypeId(item.itemTypeId);
        let area = 0.0;
        let coordinates = '';
        if (itemTemp.isEdited == true && itemTemp.mapMarkerType == "polygon") {
            coordinates = itemTemp.mapCoordinates;
            const Coordinates = coordinates.split(':');
            const positions = [];
            Coordinates.filter(coor => coor != "").map((Coordinate) => {
                const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                positions.push(pos);
            })
            const tempPolygon = new window.google.maps.Polygon({
                paths: positions
            });

            let path = tempPolygon.getPath();
            area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);

        }
        else {
            area = lmuItem.sizeHa;
            coordinates = item.mapCoordinates;
        }

        setItemModal({ showItemModal: true, itemId: itemId, item: item, action: 'Updated' });

        const masterLmus = lmu.lookUpList.masterLmuList.filter(item => item.id != itemId);

        setMasterLmuList(masterLmus);

        setFormGeneral({
            itemId: itemId,
            LmuTypeId: lmuItem.lmuTypeId,
            Name: item.name,
            Description: item.description,
            itemColour: item.colour,
            itemSizeHa: area,
            isEdited: itemTemp.isEdited
        });

        setItemMapDetail({ ...itemMapDetail, area: area, coordinates: coordinates });

        setIsNonContiguous(isNonContiguousItem);

        setHasBiodiversity(hasBiodiversity);

        setIsNonEffective(isNonEffectiveArea);

        setFormContiguous({ itemId: itemId, isNonContiguousItem: isNonContiguousItem, masterLmuId: item.lmuId, isSameAsMaster: isSameAsMaster });

        setFormDescription({ isBiodiversityReq: isBiodiversityReq, itemId: itemId, isAddsToBiodiversity: item.isAddsToBiodiversity, biodiversityComment: item.biodiversityComment });

        //Selected inherentRisks
        let inherentRisks = []
        var list = JSON.parse(JSON.stringify(inherentRisksTempList1));
        if (lmuItem.inherentRisksToFreshwater != "" && lmuItem.inherentRisksToFreshwater != null) {
            let inherentRisksArray = [];

            inherentRisksArray = lmuItem.inherentRisksToFreshwater.split(',');

            lmu.lookUpList.inherentRisksList.map(risk => {
                if (inherentRisksArray.includes(String(risk.value))) {
                    inherentRisks.push({
                        value: risk.value,
                        label: risk.label
                    })
                }
            })

            inherentRisks.forEach(function (element) {
                list.forEach(function (element1) {
                    if (element1.options.filter(x => x.label == element.label && x.value != element.value).length > 0) {
                        var obj = element1.options.filter(x => x.label == element.label && x.value != element.value)[0];
                        const findIndex = element1.options.findIndex(a => a.value === obj.value);
                        findIndex !== -1 && element1.options.splice(findIndex, 1);
                    }
                });
            });
        }

        setFormBasicDetail({
            itemId: itemId,
            isNonEffectiveArea: isNonEffectiveArea,
            effectiveArea: lmuItem.effectiveAreaHa,
            isReceivesLiquidEffluent: lmuItem.isReceivesLiquidEffluent,
            isReceivesFreshWaterIrrigation: lmuItem.isReceivesFreshWaterIrrigation,
            stemCountPerHa: lmuItem.stemCountPerHA,
            topographyId: lmuItem.topographyId,
            soilTypePredominantId: lmuItem.soilTypePredominantId,
            soilTypePredominantPercentage: lmuItem.soilTypePredominantPercentage,
            soilTypeOtherId: lmuItem.soilTypeOther,
            soilTypeOtherPercentage: lmuItem.soilTypeOtherPercentage,
            drainabilityPredominant: lmuItem.drainabilityPredominant,
            drainabilityOther: lmuItem.drainabilityOther,
            inherentRisks: inherentRisks,
            isLeasedBlock: lmuItem.isLeasedBlock,
            leasedAreaHa: lmuItem.leasedAreaHa,
            topographyList: lmu.lookUpList.topographyList,
            soilTypePredominantList: lmu.lookUpList.soilTypePredominantList,
            soilTypeOtherList: lmu.lookUpList.soilTypeOtherList,
            drainabilityPredominantList: lmu.lookUpList.drainabilityPredominantList,
            drainabilityOtherList: lmu.lookUpList.drainabilityOtherList,
            inherentRisksList: list
        });

        //Selected enterprise Type
        let enterpriseTypes = []

        if (lmuItem.enterpriseType != "" && lmuItem.enterpriseType != null) {
            let enterpriseTypesArray = [];

            enterpriseTypesArray = lmuItem.enterpriseType.split(',');

            lmu.lookUpList.allLUsEnterpriseTypeList.filter(x => x.itemId == lmuItem.itemId).map(type => {
                if (enterpriseTypesArray.includes(String(type.value))) {
                    enterpriseTypes.push({
                        value: type.value,
                        label: type.label,
                        enterpriseTypeText: type.enterpriseTypeText,
                        isDisabled: type.isDisabled
                    })
                }
            })
        }
        var showFrostProtection = false;
        if (enterpriseTypes.filter(x => x.enterpriseTypeText == "Horticulture").length > 0) {
            showFrostProtection = true;
        }
        setFormEnterpriseDetail({
            itemId: itemId,
            enterpriseType: enterpriseTypes,
            enterpriseDefinition: lmuItem.enterpriseDefinition,
            generalFarmingActivities: lmuItem.generalFarmingActivities,
            enterpriseTypeList: lmu.lookUpList.allLUsEnterpriseTypeList.filter(x => x.itemId == lmuItem.itemId),
            enterpriseDefinitionList: lmu.lookUpList.enterpriseDefinitionList,
            IsLUDoesNotHaveAnyFarmingOrGrowingActivities: lmuItem.isLUDoesNotHaveAnyFarmingOrGrowingActivities, FrostProtection: lmuItem.frostProtection, ShowFrostProtection: showFrostProtection
        })

        setFormRisk({
            isRisk: item.isItemHaveAnyRisk == 'Yes' ? 'Yes' : 'No',
            riskComment: item.riskDescription == null ? '' : item.riskDescription,
            isMitigated: item.isMitigated,
            mitigatedComment: item.mitigatedDescription == null ? '' : item.mitigatedDescription,
        });

        setFormPastureDrainage({
            dominantPastureSpecies: lmuItem.dominantPastureSpecies,
            pastureBlockProductivityPercentage: lmuItem.pastureBlockProductivityPercentage,
            isArtificiallyDrained: lmuItem.isArtificiallyDrained,
            artificiallyDrainedPercentage: lmuItem.artificiallyDrainedPercentage,
            artificialDrainageType: lmuItem.artificialDrainageType,
            susceptibilityToPugging: lmuItem.susceptibilityPugging,
            irrigationScheduled: lmuItem.irrigationScheduled,
            dominantPastureSpeciesList: lmu.lookUpList.dominantPastureSpeciesList,
            artificialDrainageTypeList: lmu.lookUpList.artificialDrainageTypeList,
            susceptibilityToPuggingList: lmu.lookUpList.susceptibilityToPuggingList,
            irrigationScheduledList: lmu.lookUpList.irrigationScheduledList,
        });

        lmuItem.lmuSoils.forEach(s => {
            delete s.createdOn;
            delete s.updatedOn;
        })

        lmuItem.lmuStrengths.forEach(s => {
            delete s.createdOn;
            delete s.updatedOn;
        })

        lmuItem.lmuWeaknesses.forEach(w => {
            delete w.createdOn;
            delete w.updatedOn;
        })

        setFormSoil({
            ...formSoil,
            lmuId: lmuItem.id,
            soilDetail: lmuItem.lmuSoils,
            soilMapGroupsList: lmu.lookUpList.soilMapGroupsList,
            soilMapOrdersList: lmu.lookUpList.soilMapOrdersList,
        });

        setFormStrengths({
            ...formStrengths,
            lmuId: lmuItem.id,
            strengths: lmuItem.lmuStrengths,
            strengthsDetailList: lmu.lookUpList.lmuStrengthsList,
        });

        setFormWeaknesses({
            ...formWeaknesses,
            lmuId: lmuItem.id,
            weaknesses: lmuItem.lmuWeaknesses,
            weaknessesDetailList: lmu.lookUpList.lmuWeaknessesList,
        });
    }

    const editMapItemFromNavigation = (itemId, itemsList, lmu) => {

        const item = itemsList.filter(item => item.id == itemId)[0];
        const lmuItem = item?.lmuItems[0];
        const isNonContiguousItem = item.isConnectedToAnotherLMU == null || item.isConnectedToAnotherLMU == false || item.isConnectedToAnotherLMU == undefined ? false : true
        const isNonEffectiveArea = lmuItem.isNonEffectiveArea == null || lmuItem.isNonEffectiveArea == false || lmuItem.isNonEffectiveArea == undefined ? false : true
        const isSameAsMaster = lmuItem.isSameAsMaster == null || lmuItem.isSameAsMaster == false || lmuItem.isSameAsMaster == undefined ? false : true
        setTypeId(item.itemTypeId);
        setItemModal({ showItemModal: true, itemId: itemId, item: item });

        const masterLmus = lmu.lookUpList.masterLmuList.filter(item => item.id != itemId);

        setMasterLmuList(masterLmus);

        setFormGeneral({
            itemId: itemId,
            LmuTypeId: lmuItem.lmuTypeId,
            Name: item.name,
            Description: item.description,
            itemColour: item.colour,
            itemSizeHa: lmuItem.sizeHa,
        });

        setItemMapDetail({ ...itemMapDetail, area: lmuItem.sizeHa, coordinates: item.mapCoordinates });

        setIsNonContiguous(isNonContiguousItem);

        setIsNonEffective(isNonEffectiveArea);

        setFormContiguous({ itemId: itemId, isNonContiguousItem: isNonContiguousItem, masterLmuId: item.lmuId, isSameAsMaster: isSameAsMaster });

        setFormDescription({ itemId: itemId, isAddsToBiodiversity: item.isAddsToBiodiversity, biodiversityComment: item.biodiversityComment });

        //Selected inherentRisks
        let inherentRisks = []
        var list = JSON.parse(JSON.stringify(inherentRisksTempList1));
        if (lmuItem.inherentRisksToFreshwater != "" && lmuItem.inherentRisksToFreshwater != null) {
            let inherentRisksArray = [];

            inherentRisksArray = lmuItem.inherentRisksToFreshwater.split(',');

            lmu.lookUpList.inherentRisksList.map(risk => {
                if (inherentRisksArray.includes(String(risk.value))) {
                    inherentRisks.push({
                        value: risk.value,
                        label: risk.label
                    })
                }
            })
            inherentRisks.forEach(function (element) {
                list.forEach(function (element1) {
                    if (element1.options.filter(x => x.label == element.label && x.value != element.value).length > 0) {
                        var obj = element1.options.filter(x => x.label == element.label && x.value != element.value)[0];
                        const findIndex = element1.options.findIndex(a => a.value === obj.value);
                        findIndex !== -1 && element1.options.splice(findIndex, 1);
                    }
                });
            });
        }

        setFormBasicDetail({
            itemId: itemId,
            isNonEffectiveArea: isNonEffectiveArea,
            effectiveArea: lmuItem.effectiveAreaHa,
            isReceivesLiquidEffluent: lmuItem.isReceivesLiquidEffluent,
            isReceivesFreshWaterIrrigation: lmuItem.isReceivesFreshWaterIrrigation,
            stemCountPerHa: lmuItem.stemCountPerHA,
            topographyId: lmuItem.topographyId,
            soilTypePredominantId: lmuItem.soilTypePredominantId,
            soilTypePredominantPercentage: lmuItem.soilTypePredominantPercentage,
            soilTypeOtherId: lmuItem.soilTypeOther,
            soilTypeOtherPercentage: lmuItem.soilTypeOtherPercentage,
            drainabilityPredominant: lmuItem.drainabilityPredominant,
            drainabilityOther: lmuItem.drainabilityOther,
            inherentRisks: inherentRisks,
            isLeasedBlock: lmuItem.isLeasedBlock,
            leasedAreaHa: lmuItem.leasedAreaHa,
            topographyList: lmu.lookUpList.topographyList,
            soilTypePredominantList: lmu.lookUpList.soilTypePredominantList,
            soilTypeOtherList: lmu.lookUpList.soilTypeOtherList,
            drainabilityPredominantList: lmu.lookUpList.drainabilityPredominantList,
            drainabilityOtherList: lmu.lookUpList.drainabilityOtherList,
            inherentRisksList: list
        });

        //Selected enterprise Type
        let enterpriseTypes = []

        if (lmuItem.enterpriseType != "" && lmuItem.enterpriseType != null) {
            let enterpriseTypesArray = [];

            enterpriseTypesArray = lmuItem.enterpriseType.split(',');

            lmu.lookUpList.allLUsEnterpriseTypeList.filter(x => x.itemId == lmuItem.itemId).map(type => {
                if (enterpriseTypesArray.includes(String(type.value))) {
                    enterpriseTypes.push({
                        value: type.value,
                        label: type.label,
                        enterpriseTypeText: type.enterpriseTypeText,
                        isDisabled: type.isDisabled
                    })
                }
            })
        }

        setFormEnterpriseDetail({
            itemId: itemId,
            enterpriseType: enterpriseTypes,
            enterpriseDefinition: lmuItem.enterpriseDefinition,
            generalFarmingActivities: lmuItem.generalFarmingActivities,
            enterpriseTypeList: lmu.lookUpList.allLUsEnterpriseTypeList.filter(x => x.itemId == lmuItem.itemId),
            enterpriseDefinitionList: lmu.lookUpList.enterpriseDefinitionList, FrostProtection: lmuItem.frostProtection
        })

        setFormRisk({
            isRisk: item.isItemHaveAnyRisk == 'Yes' ? 'Yes' : 'No',
            riskComment: item.riskDescription == null ? '' : item.riskDescription,
            isMitigated: item.isMitigated,
            mitigatedComment: item.mitigatedDescription == null ? '' : item.mitigatedDescription,
        });

        setFormPastureDrainage({
            dominantPastureSpecies: lmuItem.dominantPastureSpecies,
            pastureBlockProductivityPercentage: lmuItem.pastureBlockProductivityPercentage,
            isArtificiallyDrained: lmuItem.isArtificiallyDrained,
            artificiallyDrainedPercentage: lmuItem.artificiallyDrainedPercentage,
            artificialDrainageType: lmuItem.artificialDrainageType,
            susceptibilityToPugging: lmuItem.susceptibilityPugging,
            irrigationScheduled: lmuItem.irrigationScheduled,
            dominantPastureSpeciesList: lmu.lookUpList.dominantPastureSpeciesList,
            artificialDrainageTypeList: lmu.lookUpList.artificialDrainageTypeList,
            susceptibilityToPuggingList: lmu.lookUpList.susceptibilityToPuggingList,
            irrigationScheduledList: lmu.lookUpList.irrigationScheduledList,
        });

        lmuItem.lmuSoils.forEach(s => {
            delete s.createdOn;
            delete s.updatedOn;
        })

        lmuItem.lmuStrengths.forEach(s => {
            delete s.createdOn;
            delete s.updatedOn;
        })

        lmuItem.lmuWeaknesses.forEach(w => {
            delete w.createdOn;
            delete w.updatedOn;
        })

        setFormSoil({
            ...formSoil,
            lmuId: lmuItem.id,
            soilDetail: lmuItem.lmuSoils,
            soilMapGroupsList: lmu.lookUpList.soilMapGroupsList,
            soilMapOrdersList: lmu.lookUpList.soilMapOrdersList,
        });

        setFormStrengths({
            ...formStrengths,
            lmuId: lmuItem.id,
            strengths: lmuItem.lmuStrengths,
            strengthsDetailList: lmu.lookUpList.lmuStrengthsList,
        });

        setFormWeaknesses({
            ...formWeaknesses,
            lmuId: lmuItem.id,
            weaknesses: lmuItem.lmuWeaknesses,
            weaknessesDetailList: lmu.lookUpList.lmuWeaknessesList,
        });
    }

    const editMapMultiItem = (mapItem, selecteditemList) => {

        let masterLmus = lmu.lookUpList.masterLmuList;
        selecteditemList.forEach(selecteditem => {
            masterLmus = masterLmus.filter(item => item.id !== selecteditem);
        })
        if (masterLmus.length > 0) {
            setMultiItemModal({ ...multiItemModal, showMultiItemModal: true, itemList: selecteditemList });
            setIsNonContiguous(true);
            setMasterLmuList(masterLmus);
            setFormContiguous({ isNonContiguousItem: true, isSameAsMaster: true, masterLmuId: 0 });
        }

    }

    const handleEditItem = (e) => {
        const itemId = e.target.id;
        editMapItem([], itemId, false);
    }

    const handleDeleteItem = (e) => {
        const itemId = e.target.id;
        setItemDeleteModal({ showModal: true, itemId: itemId })
    }

    const handleItemModalShowHide = () => {

        if (itemModal.showItemModal) {
            getLmu();
        }
        setTypeId(0);
        setItemModal({ showItemModal: !itemModal.showItemModal, itemId: '', item: [] });
        setMapDetails({ ...mapDetails, isClear: true });
        setTimeout(() => {
             const scrollableDiv = document.getElementById("bodyid");

            if (scrollableDiv) {
                scrollableDiv.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top
            }
        }, 400);

    }

    const handleMultiItemModalShowHide = () => {
        setMultiItemModal({ ...multiItemModal, showMultiItemModal: !multiItemModal.showMultiItemModal, itemList: [] });
        setIsNonContiguous(false);
        setMasterLmuList([]);
        setFormContiguous({ isNonContiguousItem: false, isSameAsMaster: false, masterLmuId: 0 });
        setMapDetails({ ...mapDetails, isClear: true });
    }

    const handleItemDeleteModalClose = () => {
        setItemDeleteModal({ showModal: false, itemId: 0 });
    }

    const handleItemDeleteModalShowHide = () => {

        setItemDeleteModal({ showModal: !itemDeleteModal.showModal, itemId: '' });
    }
    const handleIsLUDoesNotHaveAnyFarmingOrGrowingActivitiesChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (checked) {
            setFormEnterpriseDetail({ ...formEnterpriseDetail, [name]: type == 'checkbox' ? checked : checked, enterpriseType: '' });
        }
        else {
            if (formEnterpriseDetail.enterpriseTypeList.length == 1) {
                setFormEnterpriseDetail({ ...formEnterpriseDetail, [name]: type == 'checkbox' ? checked : checked, enterpriseType: formEnterpriseDetail.enterpriseTypeList });
            }
            else {
                setFormEnterpriseDetail({ ...formEnterpriseDetail, [name]: type == 'checkbox' ? checked : checked });
            }
        }
    }

    const handleFormFieldChange = (e) => {

        const { name, value, checked, type } = e.target;
        const masterLmuId = parseInt(formContiguous.masterLmuId);
        if (name == 'soilTypePredominantPercentage' || name == 'soilTypeOtherPercentage') {
            if (!value || value.match(/^\d{1,}(\.\d{0,4})?$/)) {
                setFormBasicDetail({ ...formBasicDetail, [name]: type == 'checkbox' ? checked : value });
            }
        }
        else {
            if (name == "isSameAsMaster") {
                if (document.getElementById('labelErr' + e.target.id) != undefined && document.getElementById('labelErr' + e.target.id) != null) {
                    document.getElementById('labelErr' + e.target.id).remove();
                }
                if (document.getElementById('labelErrBr' + e.target.id) != undefined && document.getElementById('labelErrBr' + e.target.id) != null) {
                    document.getElementById('labelErrBr' + e.target.id).remove();
                }
                setResetIsMasterDetails(checked);
                setFormContiguous({ ...formContiguous, [name]: type == 'checkbox' ? masterLmuId > 0 ? checked : false : value });
            }
            else {

                setFormGeneral({ ...formGeneral, [name]: type == 'checkbox' ? checked : value });

                if (name == "isNonContiguousItem" && checked == false) {
                    if (formContiguous.isSameAsMaster) {
                        setResetIsMasterDetails(false);
                    }
                    setFormContiguous({ ...formContiguous, masterLmuId: 0, [name]: type == 'checkbox' ? checked : value, isSameAsMaster: false });
                }
                else if (name == "masterLmuId") {
                    if (formContiguous.isSameAsMaster) {
                        setResetIsMasterDetails(false);
                    }
                    setFormContiguous({ ...formContiguous, [name]: type == 'checkbox' ? checked : value });
                }
                else if (name == 'isNonContiguousItem') {
                    setFormContiguous({ ...formContiguous, [name]: type == 'checkbox' ? checked : value, isSameAsMaster: true });
                    setFormDescription({ ...formDescription, [name]: type == 'checkbox' ? checked : value });
                    setFormBasicDetail({ ...formBasicDetail, [name]: type == 'checkbox' ? checked : value });
                    setFormEnterpriseDetail({ ...formEnterpriseDetail, [name]: type == 'checkbox' ? checked : value });
                }
                else {
                    setFormContiguous({ ...formContiguous, [name]: type == 'checkbox' ? checked : value });
                    setFormDescription({ ...formDescription, [name]: type == 'checkbox' ? checked : value });
                    setFormBasicDetail({ ...formBasicDetail, [name]: type == 'checkbox' ? checked : value });
                    setFormEnterpriseDetail({ ...formEnterpriseDetail, [name]: type == 'checkbox' ? checked : value });
                    setFormPastureDrainage({ ...formPastureDrainage, [name]: type == 'checkbox' ? checked : value });
                }

                name == "isNonContiguousItem" && checked == false ? setIsNonContiguous(false) : setIsNonContiguous(isNonContiguous)
                name == "isNonEffectiveArea" && checked == false ? setIsNonEffective(false) : setIsNonEffective(isNonEffective)
                name == "isAddsToBiodiversity" && checked == false ? setHasBiodiversity(false) : setHasBiodiversity(hasBiodiversity)

                if (name == "isNonContiguousItem" && checked == true) {
                    setIsNonContiguous(true);
                }

                if (name == "isNonEffectiveArea" && checked == true) {
                    setIsNonEffective(true);
                }

                if (name == "isAddsToBiodiversity" && checked == true) {
                    setHasBiodiversity(true);
                }
            }
        }
    }

    const setResetIsMasterDetails = (e, checked) =>
    {
        const masterLmuId = parseInt(formContiguous.masterLmuId);
        const itemId = parseInt(formContiguous.itemId);

        if (masterLmuId != 0 && checked == true) {
            const parentLUDetails = itemsList.filter(parentLU => parentLU.id == masterLmuId)[0];
            const parentLmuItem = parentLUDetails?.lmuItems[0];
            const color = parentLUDetails.colour;
            setFormGeneral({ ...formGeneral, itemColour: color })

            setFormBasicDetail({
                ...formBasicDetail,
                isReceivesLiquidEffluent: parentLmuItem.isReceivesLiquidEffluent,
                isReceivesFreshWaterIrrigation: parentLmuItem.isReceivesFreshWaterIrrigation,
                isLeasedBlock: parentLmuItem.isLeasedBlock,
            });
        }
        else if (checked == false){
            const LUDetails = itemsList.filter(childLU => childLU.id == itemId)[0];
            if (LUDetails != null) {
                const LmuItem = LUDetails?.lmuItems[0];

                setFormBasicDetail({
                    ...formBasicDetail,
                    isReceivesLiquidEffluent: LmuItem.isReceivesLiquidEffluent,
                    isReceivesFreshWaterIrrigation: LmuItem.isReceivesFreshWaterIrrigation,
                    isLeasedBlock: LmuItem.isLeasedBlock,
                });
            }
            else {
                setFormBasicDetail({
                    ...formBasicDetail,
                    isReceivesLiquidEffluent: false,
                    isReceivesFreshWaterIrrigation: false,
                    isLeasedBlock: false,
                });
                
            }
        }
    }

    const setResetChildColor = (e, checked, masterLmu) => {
        const masterLmuId = parseInt(masterLmu);
        const itemId = parseInt(formContiguous.itemId);

        if (masterLmuId != 0 && checked == true) {
            const parentLUDetails = itemsList.filter(parentLU => parentLU.id == masterLmuId)[0];
            const color = parentLUDetails.colour;
            setFormGeneral({ ...formGeneral, itemColour: color })
        }
        else
        {
            const LUDetails = itemsList.filter(childLU => childLU.id == itemId)[0];
            if (LUDetails != null) {
                const color = LUDetails.colour;
                setFormGeneral({ ...formGeneral, itemColour: color })
            }
            else {
                setFormGeneral({ ...formGeneral, itemColour: '#41533d' })
            }
        }
    }

    const handleItemPopupRisk = (e) => {
        const { name, value, checked, type } = e.target;
        setFormRisk({ ...formRisk, [name]: type == 'checkbox' ? checked : value });
    }

    const handleOpenActionPopup = (itemId, actionId) => {
        const itemDetails = lmu.itemList.filter(item => item.id == itemId)[0];
        if (itemDetails != undefined) {
            setActionModal({ ...actionModal, showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
        }
    };

    const handleClosedActionShow = (e) => {
        setIsClosedActionShow(e.target.checked);
    }

    const handleActionClose = () => {
        setActionModal({ ...actionModal, showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    const handleNavigateOpenActionPopup = (itemId, actionId, itemList) => {
        const itemDetails = itemList.filter(items => items.itemId == itemId)[0];
        setActionModal({ ...actionModal, showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
    };

    const handleDeleteItemConfirm = async (event) => {
        const itemid = itemDeleteModal.itemId;

        try {
            const response = await apiGet(
                '/api/lmu/deleteItem/', {
                params: {
                    itemId: itemid
                }
            });
            if (response.data != null) {
                toast.success("LMU details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                const response = await apiGet(
                    '/api/lmu/getLmu/', {
                    params: {
                        farmId: farmId
                    }
                });
                const itemsList = response.data.itemsList;
                itemsList.forEach((item) => {
                    item.nonContiguousItems = [];

                    itemsList.map(nc => {
                        if (nc.lmuId === item.id) {
                            item.nonContiguousItems.push(nc);
                        }
                    })

                })
                const lmuList = itemsList.map(item => item.lmuItems[0])
                const effectiveLmuList = lmuList.filter(item => !item.isNonEffectiveArea)
                let effectiveAreaTotal = 0;
                let totalArea = 0;

                lmuList.forEach(lmu => {
                    totalArea += lmu.sizeHa;
                })
                effectiveLmuList.forEach(lmu => {
                    effectiveAreaTotal += lmu.effectiveAreaHa > 0 ? lmu.effectiveAreaHa : lmu.sizeHa;
                })
                setMasterLmuList(response.data.lookUpList.masterLmuList);
                setBlockSummary({ total: lmuList.length, effective: effectiveLmuList.length, totalArea: totalArea, totalEffectiveArea: effectiveAreaTotal })
                setLmu({ ...lmu, itemList: itemsList, lookUpList: response.data.lookUpList });
                setItemsList(itemsList);
                setItemModal({ ...itemModal, showItemModal: false });
                resetItemModal();
                setMapDetails({ ...mapDetails, isClear: true });
                setItemDeleteModal({ showModal: false, itemId: 0 });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const handleItemSave = async () => {
        setSaving(true);
        var isError = false;
        var additionalInfoError = false;
        if (formBasicDetail.topographyId == 0 && !formContiguous.isNonContiguousItem) {
            var parent1 = document.getElementById('topographyId').parentElement;
            var label3 = document.getElementById('labelErr' + document.getElementById('topographyId').parentElement.id);
            if (label3 != undefined && label3 != null) {
                label3.innerHTML = "Please select topography";
            }
            else {
                var newlabel1 = document.createElement("Label");
                newlabel1.setAttribute("class", 'errorMessage');
                newlabel1.setAttribute("id", 'labelErr' + parent1.id);
                newlabel1.innerHTML = "Please select topography";
                parent1.append(newlabel1);
            }
            isError = true;
            additionalInfoError = true;
        }
        else {
            if (document.getElementById('topographyId') != undefined && document.getElementById('topographyId') != null) {
                var label1 = document.getElementById('labelErr' + document.getElementById('topographyId').parentElement.id);
                if (label1 != undefined && label1 != null) {
                    label1.innerHTML = "";
                }
            }
        }
        if (formBasicDetail.soilTypePredominantId == 0 && !formContiguous.isNonContiguousItem) {
            var parent2 = document.getElementById('soilTypePredominantId').parentElement;
            var label4 = document.getElementById('labelErr' + document.getElementById('soilTypePredominantId').parentElement.id);
            if (label4 != undefined && label4 != null) {
                label4.innerHTML = "Please select soil type (predominant)";
            }
            else {
                var newlabel2 = document.createElement("Label");
                newlabel2.setAttribute("class", 'errorMessage');
                newlabel2.setAttribute("id", 'labelErr' + parent2.id);
                newlabel2.innerHTML = "Please select soil type (predominant)";
                parent2.append(newlabel2);
            }
            isError = true;
            additionalInfoError = true;
        }
        else {
            if (document.getElementById('soilTypePredominantId') != undefined && document.getElementById('soilTypePredominantId') != null) {
                var label2 = document.getElementById('labelErr' + document.getElementById('soilTypePredominantId').parentElement.id);
                if (label2 != undefined && label2 != null) {
                    label2.innerHTML = "";
                }
            }
        }
        if (additionalInfoError) {
            setAdditionalInfoIsOpen(true)
            setAdditionalInfoIsIconUp(true)
        }
        if (formContiguous.isSameAsMaster) {
            if (formContiguous.masterLmuId == 0) {
                var parent = document.getElementById('masterLmuId').parentElement;
                var newlabel = document.createElement("Label");
                newlabel.setAttribute("class", 'errorMessage');
                newlabel.setAttribute("id", 'labelErr' + parent.id);
                newlabel.innerHTML = "Please select a Parent LU";
                parent.append(newlabel);
                
                isError = true;
            }
            else {
                var label = document.getElementById('labelErr' + document.getElementById('masterLmuId').parentElement.id);
                if (label != undefined && label != null) {
                    label.innerHTML = "";
                }
                setResetIsMasterDetails(true);
            }
        }

        let inherentRisks = '';

        if (Array.isArray(formBasicDetail.inherentRisks)) {
            let inherentRisksArr = [];
            formBasicDetail.inherentRisks.forEach(risk => {
                inherentRisksArr.push(risk.value);
            })
            inherentRisks = inherentRisksArr.join(",");
        } else {
            inherentRisks = formBasicDetail.inherentRisks.toString();
        }
        if (inherentRisks == '' && !formContiguous.isNonContiguousItem) {
            var parent3 = document.getElementById('hdninherentRisks').parentElement;
            var label5 = document.getElementById('labelErr' + document.getElementById('hdninherentRisks').parentElement.id);
            if (label5 != undefined && label5 != null) {
                label5.innerHTML = "Please select at least 1 inherent vulnerability";
            }
            else {
                var newlabel6 = document.createElement("Label");
                newlabel6.setAttribute("class", 'errorMessage');
                newlabel6.setAttribute("id", 'labelErr' + parent3.id);
                newlabel6.innerHTML = "Please select at least 1 inherent vulnerability";
                parent3.append(newlabel6);
            }
            isError = true;
        }
        else {
            if (document.getElementById('hdninherentRisks') != undefined && document.getElementById('hdninherentRisks') != null) {
                var label8 = document.getElementById('labelErr' + document.getElementById('hdninherentRisks').parentElement.id);
                if (label8 != undefined && label8 != null) {
                    label8.innerHTML = "";
                }
            }
        }

        let enterpriseTypes = '';
        if (formEnterpriseDetail.enterpriseTypeList.length == 1) {
            if (!formEnterpriseDetail.IsLUDoesNotHaveAnyFarmingOrGrowingActivities) {
                if (Array.isArray(formEnterpriseDetail.enterpriseType)) {
                    let enterpriseTypesArr = [];
                    formEnterpriseDetail.enterpriseType.forEach(type => {
                        enterpriseTypesArr.push(type.value);
                    })
                    enterpriseTypes = enterpriseTypesArr.join(",");
                } else if (typeof formEnterpriseDetail.enterpriseType === 'object') {

                    enterpriseTypes = formEnterpriseDetail.enterpriseType.value.toString();
                }
                else {
                    enterpriseTypes = formEnterpriseDetail.enterpriseType.toString();
                }
            }
            else {
                enterpriseTypes = '';
            }
        }
        else {
            if (Array.isArray(formEnterpriseDetail.enterpriseType)) {
                let enterpriseTypesArr = [];
                formEnterpriseDetail.enterpriseType.forEach(type => {
                    enterpriseTypesArr.push(type.value);
                })
                enterpriseTypes = enterpriseTypesArr.join(",");
            } else {
                enterpriseTypes = formEnterpriseDetail.enterpriseType.toString();
            }
        }

        //if (enterpriseTypes == '' && !formEnterpriseDetail.IsLUDoesNotHaveAnyFarmingOrGrowingActivities) {
        //    var parent4 = document.getElementById('hdnenterpriseType').parentElement;
        //    var label7 = document.getElementById('labelErr' + document.getElementById('hdnenterpriseType').parentElement.id);
        //    if (label7 != undefined && label7 != null) {
        //        label7.innerHTML = "Please select at least 1 farming activity";
        //    }
        //    else {
        //        var newlabel7 = document.createElement("Label");
        //        newlabel7.setAttribute("class", 'errorMessage');
        //        newlabel7.setAttribute("id", 'labelErr' + parent4.id);
        //        newlabel7.innerHTML = "Please select at least 1 farming activity";
        //        parent4.append(newlabel7);
        //    }
        //    setEnterpriseIsOpen(true)
        //    setEnterpriseIsIconUp(true)
        //    isError = true;
        //}
        //else {
        //    if (document.getElementById('hdnenterpriseType') != undefined && document.getElementById('hdnenterpriseType') != null) {
        //        var label9 = document.getElementById('labelErr' + document.getElementById('hdnenterpriseType').parentElement.id);
        //        if (label9 != undefined && label9 != null) {
        //            label9.innerHTML = "";
        //        }
        //    }
        //}

        if (isError) {
            setSaving(false);
            return false;
        }
        const form = {
            Id: formGeneral.itemId,
            FarmId: farmId,
            ItemTypeId: typeId,
            IsConnectedToAnotherLMU: formContiguous.isNonContiguousItem,
            LMUId: formContiguous.masterLmuId,
            Name: formGeneral.Name,
            Description: formGeneral.Description,
            Colour: formGeneral.itemColour,
            IsAddsToBioDiversity: formDescription.isAddsToBiodiversity,
            BioDiversityComment: formDescription.biodiversityComment,
            IsItemHaveAnyRisk: formRisk.isRisk,
            RiskDescription: formRisk.riskComment,
            IsMitigated: formRisk.isMitigated,
            MitigatedDescription: formRisk.mitigatedComment,
            MapMarkerType: 'polygon',
            MapCoordinates: itemMapDetail.coordinates,
            IsAchievementOfNote: false,  // todo
            AchievementOfNoteComments: '',  // todo
            IsActive: true,
            UpdatedBy: userId,
            isEdited: formGeneral.isEdited,
            LmuItem: {
                IsNonEffectiveArea: formBasicDetail.isNonEffectiveArea,
                LmuTypeId: parseInt(formGeneral.LmuTypeId),
                EffectiveAreaHa: formBasicDetail.isNonEffectiveArea == false ? formBasicDetail.effectiveArea : 0.0,
                SizeHa: itemMapDetail.area,
                IsReceivesLiquidEffluent: formBasicDetail.isReceivesLiquidEffluent,
                IsReceivesFreshWaterIrrigation: formBasicDetail.isReceivesFreshWaterIrrigation,
                StemCountPerHA: formBasicDetail.stemCountPerHa,
                TopographyId: formBasicDetail.topographyId,
                SoilTypePredominantId: formBasicDetail.soilTypePredominantId,
                SoilTypePredominantPercentage: formBasicDetail.soilTypePredominantPercentage,
                SoilTypeOther: formBasicDetail.soilTypeOtherId,
                SoilTypeOtherPercentage: formBasicDetail.soilTypeOtherPercentage,
                DrainabilityPredominant: formBasicDetail.drainabilityPredominant,
                DrainabilityOther: formBasicDetail.drainabilityOther,
                EnterpriseType: enterpriseTypes,
                EnterpriseDefinition: formEnterpriseDetail.enterpriseDefinition,
                GeneralFarmingActivities: formEnterpriseDetail.generalFarmingActivities,
                InherentRisksToFreshwater: inherentRisks,
                IsLeasedBlock: formBasicDetail.isLeasedBlock,
                LeasedAreaHa: formBasicDetail.isLeasedBlock == true ? formBasicDetail.leasedAreaHa : 0.0,
                DominantPastureSpecies: formPastureDrainage.dominantPastureSpecies,
                PastureBlockProductivityPercentage: formPastureDrainage.pastureBlockProductivityPercentage,
                IsArtificiallyDrained: formPastureDrainage.isArtificiallyDrained,
                ArtificiallyDrainedPercentage: formPastureDrainage.artificiallyDrainedPercentage,
                ArtificialDrainageType: formPastureDrainage.artificialDrainageType,
                SusceptibilityPugging: formPastureDrainage.susceptibilityToPugging,
                IrrigationScheduled: formPastureDrainage.irrigationScheduled,
                IsActive: true,
                UpdatedBy: userId,
                LMUSoils: formSoil.soilDetail,
                LMUStrengths: formStrengths.strengths,
                LMUWeaknesses: formWeaknesses.weaknesses,
                IsSameAsMaster: formContiguous.isSameAsMaster,
                IsLUDoesNotHaveAnyFarmingOrGrowingActivities: formEnterpriseDetail.IsLUDoesNotHaveAnyFarmingOrGrowingActivities,
                FrostProtection: formEnterpriseDetail.FrostProtection
            },
            ImageUploadList: []
        }
        for (var i = 0; i < imageUploadList.length; i++) {
            var obj = {};
            obj.Id = imageUploadList[i].id;
            obj.ImageDetail = imageUploadList[i].imageDetail;
            obj.ImageName = imageUploadList[i].imageName;
            obj.ImagePhysicalName = imageUploadList[i].imagePhysicalName;
            obj.ImagePath = imageUploadList[i].imagePath;
            form.ImageUploadList.push(obj);
        }
        try {
            if (!Validate(form)) {
                const response = await apiPost(
                    '/api/lmu/saveItem/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                    });
                if (response.data != null) {
                    const response = await apiGet(
                        '/api/lmu/getLmu/', {
                        params: {
                            farmId: farmId
                        }
                    });
                    const itemsList = response.data.itemsList;
                    
                    itemsList.forEach((item) => {
                        item.nonContiguousItems = [];

                        itemsList.map(nc => {
                            if (nc.lmuId === item.id) {
                                item.nonContiguousItems.push(nc);
                            }
                        })

                    })
                    const lmuList = itemsList.map(item => item.lmuItems[0])
                    const effectiveLmuList = lmuList.filter(item => !item.isNonEffectiveArea)
                    let effectiveAreaTotal = 0;
                    let totalArea = 0;

                    lmuList.forEach(lmu => {
                        totalArea += lmu.sizeHa;
                    })
                    effectiveLmuList.forEach(lmu => {
                        effectiveAreaTotal += lmu.effectiveAreaHa > 0 ? lmu.effectiveAreaHa : lmu.sizeHa;
                    })
                    setMasterLmuList(response.data.lookUpList.masterLmuList);
                    setBlockSummary({ total: lmuList.length, effective: effectiveLmuList.length, totalArea: totalArea, totalEffectiveArea: effectiveAreaTotal })
                    setLmu({ ...lmu, itemList: itemsList, lookUpList: response.data.lookUpList });
                    setItemsList(itemsList);
                    setLMUItems(itemsList);
                    setSaving(false);
                    toast.success("LMU details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                    setItemModal({ ...itemModal, showItemModal: false });
                    resetItemModal();
                    setMapDetails({ ...mapDetails, isClear: true, polyType:'', joinNCLUs: false })
                }
            }
            else {
                setSaving(false);
            }
        } catch (error) {
            setSaving(false);
            console.log(error);
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message, { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("No server response", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
        refreshToken();
    }

    const handleMultiItemSave = async () => {
        setSaving(true);
        var isError = false;
        if (formContiguous.isSameAsMaster) {
            if (formContiguous.masterLmuId == 0) {
                var parent = document.getElementById('masterLmuId').parentElement;
                var newlabel = document.createElement("Label");
                newlabel.setAttribute("class", 'errorMessage');
                newlabel.setAttribute("id", 'labelErr' + parent.id);
                newlabel.innerHTML = "Please select a Parent LU";
                parent.append(newlabel);

                isError = true;
            }
            else {
                var label = document.getElementById('labelErr' + document.getElementById('masterLmuId').parentElement.id);
                if (label != undefined && label != null) {
                    label.innerHTML = "";
                }
            }
        }

        if (isError) {
            setSaving(false);
            return false;
        }

        const form = {
            FarmId: farmId,
            IsConnectedToAnotherLMU: formContiguous.isNonContiguousItem,
            MasterLMUId: formContiguous.masterLmuId,
            isSameAsMaster: formContiguous.isSameAsMaster,
            itemList: multiItemModal.itemList,
            UpdatedBy: userId
        }

        try {
            if (!Validate(form)) {
                const response = await apiPost(
                    '/api/lmu/saveMultiItems/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                    });
                if (response.data != null) {
                    const response = await apiGet(
                        '/api/lmu/getLmu/', {
                        params: {
                            farmId: farmId
                        }
                    });
                    const itemsList = response.data.itemsList;

                    itemsList.forEach((item) => {
                        item.nonContiguousItems = [];

                        itemsList.map(nc => {
                            if (nc.lmuId === item.id) {
                                item.nonContiguousItems.push(nc);
                            }
                        })

                    })
                    const lmuList = itemsList.map(item => item.lmuItems[0])
                    const effectiveLmuList = lmuList.filter(item => !item.isNonEffectiveArea)
                    let effectiveAreaTotal = 0;
                    let totalArea = 0;

                    lmuList.forEach(lmu => {
                        totalArea += lmu.sizeHa;
                    })
                    effectiveLmuList.forEach(lmu => {
                        effectiveAreaTotal += lmu.effectiveAreaHa > 0 ? lmu.effectiveAreaHa : lmu.sizeHa;
                    })
                    setMasterLmuList(response.data.lookUpList.masterLmuList);
                    setBlockSummary({ total: lmuList.length, effective: effectiveLmuList.length, totalArea: totalArea, totalEffectiveArea: effectiveAreaTotal })
                    setLmu({ ...lmu, itemList: itemsList, lookUpList: response.data.lookUpList });
                    setItemsList(itemsList);
                    setLMUItems(itemsList);
                    setSaving(false);
                    toast.success("LMU details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                    setMultiItemModal({ ...multiItemModal, showMultiItemModal: false, itemList: [] });
                    resetItemModal();
                    setMapDetails({ ...mapDetails, isClear: true, polyType: '',  joinNCLUs: false })
                }
            }
            else {
                setSaving(false);
            }
        } catch (error) {
            setSaving(false);
            console.log(error);
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message, { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("No server response", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    const handleItemClick = (event, typeid, polyType) => {
        setTypeId(typeid);
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
    };

    const handleBlockOnlySelect = (event, itemId, zoomlevel) => {
        const { name, value, checked, type } = event.target;
        let selectedItemId = 0;
        if (name == 'isViewBlockOnly' && checked == true) {
            selectedItemId = itemId;
        }
        const defaultZoomlevel = zoomlevel == null ? mapDetails.zoomLevel : zoomlevel;
        setBlockOnly({ ...blockOnly, itemId: selectedItemId, defaultZoomLevel: defaultZoomlevel, [name]: type == 'checkbox' ? checked : value });
    }

    const handleBlockZoomlevel = (event, itemId) => {
        const { name, value, checked, type } = event.target;

        if (blockOnly.isViewBlockOnly = true && itemId == blockOnly.itemId) {
            setBlockOnly({ ...blockOnly, itemId: itemId, [name]: type == 'checkbox' ? checked : parseInt(value) });
        }
    }

    const handleCenterPinClick = (event, polyType, itemId) => {
        setBlockOnly({ ...blockOnly, itemId: itemId })
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
    }

    const handleCenterPinPopupClose = () => {
        handleClearSelection1();
        setBlockOnly({ ...blockOnly, showCenterPinPopup: false, name: '', itemid: 0, coordinates: '', actionType: '' })
        setMapDetails({ ...mapDetails, isClear: true });
        
    }

    const handleBlockZoomlevelSave = (event, itemId, value) => {
        if (blockOnly.itemId == itemId) {
            setBlockOnly({ ...blockOnly, defaultZoomLevel: value })
            handleZoomLevelSave();
        }
    }

    const handleZoomLevelSave = async () => {

        const form = {
            Id: blockOnly.id,
            ItemId: blockOnly.itemId,
            DefaultZoomlevel: blockOnly.defaultZoomLevel,
            updatedBy: userId
        }
        try {
            const response = await apiPost(
                '/api/lmu/saveDefaultZoomLevel/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                });
            if (response.data != null) {
                getLmu();
                toast.success("LMU Default Zoom level saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            }
        } catch (error) {
            console.log(error);
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message, { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("No server response", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    const handleCenterPinSave = async () => {

        const form = {
            Id: blockOnly.id,
            ItemId: blockOnly.itemId,
            CenterCoordinates: blockOnly.coordinates,
            DefaultZoomlevel: blockOnly.defaultZoomLevel,
            updatedBy: userId
        }
        try {
            const response = await apiPost(
                '/api/lmu/saveCenterPin/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                });
            if (response.data != null) {
                toast.success("LMU Center Pin saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                handleCenterPinPopupClose();
                getLmu();
            }
        } catch (error) {
            console.log(error);
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message, { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("No server response", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    const editLMUCenter = (mapItem, itemId, isDrag) => {
        let coordinates = '';
        const item = itemsList.filter(item => item.id == itemId)[0];

        if (isDrag) {
            coordinates = mapItem.latLng.lat().toFixed(6) + ", " + mapItem.latLng.lng().toFixed(6);
        }
        else {
            coordinates = item.lmuItems[0].centerCoordinates;
        }

        setBlockOnly({ ...blockOnly, itemId: itemId, name: item.name + ' - Centre Pin', coordinates: coordinates, showCenterPinPopup: true, actionType: 'Update' })

    }

    const refreshPage = () => {
        setLoading(true);
        getLmu();
    }

    const handleCenterPinDelete = async () => {
        const itemid = blockOnly.itemId;

        try {
            const response = await apiGet(
                '/api/lmu/deleteCenterPin/', {
                params: {
                    itemId: itemid
                }
            });

            if (response.data != null) {
                toast.success("LMU Center Pin deleted!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                handleCenterPinPopupClose();
                getLmu();
            }
        } catch (error) {
            console.log(error);
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message, { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("No server response", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    const handleClearSelection = () => {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
        window.location.reload(true);
    }

    const handleClearSelection1 = () => {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
    }

    const handleMultiSelectInherentRiskChange = (e) => {
        setFormBasicDetail({ ...formBasicDetail, inherentRisks: '' });
        var selectedInherentRisk = '';
        var list = JSON.parse(JSON.stringify(inherentRisksTempList1));
        e.forEach(function (element) {
            list.forEach(function (element1) {
                if (element1.options.filter(x => x.label == element.label && x.value != element.value).length > 0) {
                    var obj = element1.options.filter(x => x.label == element.label && x.value != element.value)[0];
                    const findIndex = element1.options.findIndex(a => a.value === obj.value);
                    findIndex !== -1 && element1.options.splice(findIndex, 1);
                }
            });
        });
        setFormBasicDetail({ ...formBasicDetail, inherentRisks: e, inherentRisksList: list });
    }

    const handleMultiEnterpriseTypeChange = (e) => {
        setFormEnterpriseDetail({ ...formEnterpriseDetail, enterpriseType: '' });
        let selectedEnterpriseType = '';
        setFormEnterpriseDetail({ ...formEnterpriseDetail, enterpriseType: e });
        e.forEach(function (element) {
            if (selectedEnterpriseType == '') {
                selectedEnterpriseType = element.value;
            }
            else {
                selectedEnterpriseType = selectedEnterpriseType + ',' + element.value;
            }
        });
        if (e.filter(x => x.enterpriseTypeText == "Horticulture").length > 0) {
            setFormEnterpriseDetail({ ...formEnterpriseDetail, enterpriseType: selectedEnterpriseType, ShowFrostProtection:true });
        }
        else {
            setFormEnterpriseDetail({ ...formEnterpriseDetail, enterpriseType: selectedEnterpriseType, ShowFrostProtection: false, FrostProtection:false });
        }
    }

    /*handle Toggle for nonMap View*/
    const handleItemToggle = (lmuId, isOpen, isIconUp) => {
        setToggleItemState({ ...toggleItemState, lmuId: lmuId, isOpen: isOpen, isIconUp: isIconUp })
    }
    /*handle Toggle for nonMap View*/
    const handleChildItemToggle = (lmuId, isOpen, isIconUp) => {
        setToggleChildItemState({ ...toggleChildItemState, lmuId: lmuId, isOpen: isOpen, isIconUp: isIconUp })
    }

    /*handle Item highlight*/
    const handleItemHighlight = (itemId) => {
        if (mapDetails.isHiglighted === false && itemId !== 0) {
            setMapDetails({ ...mapDetails, highlighteditemId: itemId, isHiglighted: true })
        }
        else if (mapDetails.isHiglighted === true && itemId === 0) {
            setMapDetails({ ...mapDetails, highlighteditemId: itemId, isHiglighted: false })
        }
    }

    /*handle LU Select Change*/
    const handleLUSelectChange = (event) => {
        const { name, value, checked, type } = event.target;
        let isblockOnly = false;
        let defaultZoomlevel = mapDetails.zoomLevel;
        if (value > 0) {
            isblockOnly = true;
            const item = itemsList.filter(item => item.id == value)[0];
            const lmuItem = item?.lmuItems[0];
            defaultZoomlevel = lmuItem.defaultZoomlevel == null ? mapDetails.zoomLevel : lmuItem.defaultZoomlevel;
        }
        setBlockOnly({ ...blockOnly, defaultZoomLevel: defaultZoomlevel  , isViewBlockOnly: isblockOnly, itemId: type == 'checkbox' ? checked : value });
    }

    const handleHideChildrenCheck = (event, lmuId) => {
        const { name, value, checked, type } = event.target;
        let selectedLuId = 0;
        let ishideChildren = true;
        if (name == 'childLUDisplay' && value == 1) {
            selectedLuId = lmuId;
            ishideChildren = false;
        }
        setHideChildren({ ...hideChildren, lmuId: lmuId, ishideChildren: ishideChildren, childLUDisplay : value });
    }

    /*Avoid unwanted page refresh*/
    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '80vw' : '50vw'}
                height={toggleSwitch == 'map' ? '80vw' : '50vw'}
                itemModel={lmu}
                mapDetails={mapDetails}
                addMapItem={addMapItem}
                editMapItem={editMapItem}
                blockViewOnly={blockOnly}
                editLMUCenter={editLMUCenter}
                handleMapItemEdited={handleMapItemEdited}
                gisLayerSoilDetails={gisLayerSoilDetails}
                gisLayerTopographyDetails={gisLayerTopographyDetails}
                gisLayerWetlandDetails={gisLayerWetlandDetails}
                editMapMultiItem={editMapMultiItem}
            >
            </MapView>
        )
    }, [lmu, mapDetails, blockOnly, gisLayerSoilDetails, gisLayerTopographyDetails, gisLayerWetlandDetails, toggleSwitch])

    const handleGISLayerTopographyDetails = (e) => {
        if (e.target.checked) {
            setGISLayerTopographyDetails({ ...gisLayerTopographyDetails, showGISLayer: true })
            setGISLayerSoilDetails({ ...gisLayerSoilDetails, showGISLayer: false })
            setGISLayerWetlandDetails({ ...gisLayerWetlandDetails, showGISLayer: false })
        }
        else {
            setGISLayerTopographyDetails({ ...gisLayerTopographyDetails, showGISLayer: false })
        }

    }

    const handleGISLayerSoilDetails = (e) => {
        if (e.target.checked) {
            setGISLayerTopographyDetails({ ...gisLayerTopographyDetails, showGISLayer: false })
            setGISLayerWetlandDetails({ ...gisLayerWetlandDetails, showGISLayer: false })
            setGISLayerSoilDetails({ ...gisLayerSoilDetails, showGISLayer: true })
        }
        else {
            setGISLayerSoilDetails({ ...gisLayerSoilDetails, showGISLayer: false })
        }

    }

    const handleGISLayerWetlandDetails = (e) => {
        if (e.target.checked) {
            setGISLayerTopographyDetails({ ...gisLayerTopographyDetails, showGISLayer: false })
            setGISLayerSoilDetails({ ...gisLayerSoilDetails, showGISLayer: false })
            setGISLayerWetlandDetails({ ...gisLayerWetlandDetails, showGISLayer: true })
        }
        else {
            setGISLayerWetlandDetails({ ...gisLayerWetlandDetails, showGISLayer: false })
        }

    }
    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
            document.getElementById('itemTypeListView').style.height = '70vh';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }

    const handleEditItemClick = (e) => {
        if (e.target.checked) {
            toast.error(
                (t) => (
                    <div>
                        <span>ALERT: to edit a shape or line please do the following:<br />   1) Click to select the shape or line. <br />   2) Drag the dots around to edit and make changes.  <br />   3) Double click inside the shape(or on the line) when finished then SAVE.</span>
                        <button className="toast-close-button"
                            onClick={() => toast.dismiss(t.id)}
                        >
                            OK
                        </button>
                    </div>
                ),
                {
                    duration: Infinity, style: { border: '1px solid #f76054', padding: '16*/px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', }
                }
            );
            
        }
        setMapDetails({ ...mapDetails, isFarmCenterEditable: !mapDetails.itemsEditable, isFarmOutlineEditable: !mapDetails.itemsEditable, itemsEditable: !mapDetails.itemsEditable,joinNCLUs : false })
    }

    const handleJoinNCLUsClick = (e) => {
        setMapDetails({ ...mapDetails, isFarmCenterEditable: false, isFarmOutlineEditable: false, itemsEditable: false, joinNCLUs: !mapDetails.joinNCLUs })
    }
    const noFarmCentreError = () => {
            toast.error("Please add minimum one LU to move forward ...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });   
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">Identify Land Units (LU's)</h3></Col>
                {lmu.isWizardCompleted != true && !loading &&
                    <Col>
                        {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                            <>
                            {lmu.itemList.length  > 0 ? <Button className="float-end btn-next-page" onClick={(section) => handleWizardChanged(lmu.section)}>Next <FaChevronRight /> </Button> :
                                <Button className="float-end btn-next-page-warning" onClick={noFarmCentreError}> Next <FaChevronRight /> </Button>}
                            </>
                        }
                        {roleName != 'SWNZ Admin' && farmRoleName != 'SWNZ Admin' && farmRoleName != 'Manager' && isNextButtonVisible &&
                            <>
                                <Button className="float-end btn-next-page" onClick={(section) => handleMoveToNextPage(lmu.section)}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        <Button className="float-end btn-next-page" onClick={(section) => handleWizardChangedBack(lmu.section)}>Back <FaChevronLeft /> </Button>
                    </Col>
                }
            </Row>
            <br/>
            {
                loading ?
                    <SpinnerContainer />
                    :
                    <div>
                        <Row style={{ marginTop: '10px' }}>
                            <Col id='mapView'>
                                <Row className="map-layer">
                                    <Col>
                                        <Row>
                                            <Col sm="3"> {toggleSwitch == 'map & details' &&
                                                <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                                    <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                                </Button>
                                            }
                                                {toggleSwitch == 'map' &&
                                                    <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                        <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                                    </Button>
                                                }
                                            </Col>
                                            <Col sm="1"></Col>
                                            <Col sm="8">
                                                <div className="map-item-edit-div">
                                                    <Label className="map-checkbox-label">Edit Item</Label>
                                                    <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.itemsEditable} onChange={(e) => handleEditItemClick(e)} name="isItemEdit" id="isItemEdit" />&nbsp;&nbsp;
                                                    <Label className="map-checkbox-label">Show Label</Label>
                                                    <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.showLabel} onChange={(e) => setMapDetails({ ...mapDetails, showLabel: !mapDetails.showLabel })} name="showLabel" id="showLabel" />&nbsp;&nbsp;
                                                    <Label className="map-checkbox-label">Combine Land Units</Label>
                                                    <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.joinNCLUs} onChange={(e) => handleJoinNCLUsClick(e)} name="isJoinLU" id="isJoinLU" />&nbsp;&nbsp;

                                                </div>
                                            </Col>
                                        </Row>
                                        {mapView}
                                    </Col>
                                </Row>
                            </Col>
                            <Col id="itemTypeListView" style={{ display: toggleSwitch == 'map' ? 'block' : 'none', height: "70vh", overflowY: "scroll", width: "20vw" }}>
                                <Row>
                                    <Col>
                                        <Card>
                                            <CardHeader className="item-header item_click card-header1">
                                                <Row>
                                                    <Col sm="12">
                                                        <h5 className="color-dark-teal">Separate vineyard into Land Units (LU's)&nbsp;&nbsp;&nbsp;
                                                            <img data-tooltip-id="my-tooltip-1" onClick={(e) => e.stopPropagation()} className="featureIcon" src="/images/info_button_lt.png" />
                                                        </h5>
                                                        <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                                            id="my-tooltip-1"
                                                            place="top"
                                                            variant="info"
                                                            render={({ content, activeAnchor }) => (
                                                                <>
                                                                    <Row>
                                                                        <Col>
                                                                            <p style={{ fontWeight: "lighter" }}>
                                                                                MFE FWFP Development Guide Section 3.3
                                                                                <br />
                                                                                You must divide your farm into land units.
                                                                                <br />
                                                                                When defining land units, you should consider the following features:
                                                                                <br />
                                                                                - soil types (eg, heavy soils versus free-draining soils)
                                                                                <br />
                                                                                - climate
                                                                                <br />
                                                                                - presence of irrigation
                                                                                <br />
                                                                                - presence of land drainage (surface and sub-surface).
                                                                                <br />
                                                                                Areas where the above features are similar should form a land unit. You should keep the number of land units to a minimum. You must also provide a written description of the key features of each land unit.
                                                                            </p>
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                            )}
                                                        />
                                                    </Col>
                                                </Row>
                                            </CardHeader>
                                            <CardBody>
                                                <Row>
                                                    <Col>
                                                        <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                                            <Row>
                                                                <Col sm="4" style={{display:"none"}}>
                                                                    <Row>
                                                                        <Col>
                                                                            <Label className="external-map-title">External Map Layers</Label>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col>
                                                                            <Input className="" type="checkbox" checked={gisLayerTopographyDetails.showGISLayer} onChange={handleGISLayerTopographyDetails} name="gisLayerTopographyDetails" id="gisLayerTopographyDetails" />
                                                                            {'   '}<Label className="">Show Topography map Layer</Label>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col>
                                                                            <Input className="" type="checkbox" checked={gisLayerSoilDetails.showGISLayer} onChange={handleGISLayerSoilDetails} name="gisLayerSoilDetails" id="gisLayerSoilDetails" />
                                                                            {'   '}<Label className="">Show Soil map Layer</Label>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col>
                                                                            <Input className="" type="checkbox" checked={gisLayerWetlandDetails.showGISLayer} onChange={handleGISLayerWetlandDetails} name="gisLayerWetlandDetails" id="gisLayerWetlandDetails" />
                                                                            {'   '}<Label className="">Show Wetland map Layer</Label>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col>
                                                                    <Row>
                                                                        <Col>
                                                                            <Label className="fw-bold info-text">LU's are areas of contiguous or non-contiguous land with similar natural and/or biophysical characteristics. These units are based on the natural and modified biophysical characteristics of the land. Create separate LU's where distinct differences exist in biophysical characteristics e.g., flat land versus rolling hills, or stony soil versus a deep silt.</Label>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <hr />
                                                            { /* Map Functions */}
                                                            <Row className="my-3">
                                                                <Col sm="12" key={uuid()}>
                                                                    <label className="outlineLabel para-light-sm ">Click on the
                                                                        <img className="featureIcon" src="/images/Icons/fwfp-icon-land_units.png" />
                                                                        then click on the property map and a white cross will appear. Continue to click to identify the points of your Land Unit. Double click when you have finished. You will be able to combine areas of land that share similar characteristics.</label>
                                                                    <br />
                                                                    <Row>
                                                                        {lmu.itemTypes.map(type =>
                                                                            <Col key={uuid()} sm="6" className="style-item-display">
                                                                                <Row>
                                                                                    <Col sm="12">
                                                                                        {type.markerType === "polygon" &&
                                                                                            <>
                                                                                                <img
                                                                                                    className="featureIcon"
                                                                                                src="/images/Icons/fwfp-icon-land_units.png"
                                                                                                    onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                                                            />  <label className="itemTypeStyle "> Land Units</label>
                                                                                            </>
                                                                                        }
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )}
                                                                        <Col sm="6" style={{ display: "none" }}>
                                                                            <Button className="my-3" style={{ float: "right" }} color="warning" size="sm" onClick={handleClearSelection}>
                                                                                Clear Selection
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>

                                                            {
                                                                blockOnly.islargeEnterprise == true &&
                                                                <Row>
                                                                    <Col sm="8">
                                                                        <Label>This property is large - Select Land units separately if required</Label>
                                                                    </Col>
                                                                    <Col sm="4">
                                                                        <FormGroup>
                                                                            {itemsList != undefined && itemsList != null &&
                                                                                <Input type="select" className="float-end" onChange={handleLUSelectChange} name="selectedLMUId" id="selectedLMUId" value={blockOnly.itemId}>
                                                                                    <option value={0} >Entire Farm</option>
                                                                                    {itemsList.filter(lmu => !lmu.isConnectedToAnotherLMU).map(Option =>
                                                                                        <option key={uuid()} value={Option.id}>{Option.name}</option>
                                                                                    )}
                                                                                </Input>
                                                                            }
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                            <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', marginTop: "-25px" }}>
                                <Row>
                                    <Col> {toggleSwitch == 'map & details' &&
                                        <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                            <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                        </Button>
                                    }
                                        {toggleSwitch == 'details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                                <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Card className="cardNonLeftRadius">
                                            <CardHeader className="item-header item_click card-header1">
                                                <Row>
                                                    <Col sm="12">
                                                        <h5 className="color-dark-teal">Separate vineyard into Land Units (LU's)&nbsp;&nbsp;&nbsp;
                                                            <img data-tooltip-id="my-tooltip-1" onClick={(e) => e.stopPropagation()} className="featureIcon" src="/images/info_button_lt.png" />
                                                        </h5>
                                                        <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                                            id="my-tooltip-1"
                                                            place="top"
                                                            variant="info"
                                                            render={({ content, activeAnchor }) => (
                                                                <>
                                                                    <Row>
                                                                        <Col>
                                                                            <p style={{ fontWeight: "lighter" }}>
                                                                                MFE FWFP Development Guide Section 3.3
                                                                                <br />
                                                                                You must divide your farm into land units.
                                                                                <br />
                                                                                When defining land units, you should consider the following features:
                                                                                <br />
                                                                                - soil types (eg, heavy soils versus free-draining soils)
                                                                                <br />
                                                                                - climate
                                                                                <br />
                                                                                - presence of irrigation
                                                                                <br />
                                                                                - presence of land drainage (surface and sub-surface).
                                                                                <br />
                                                                                Areas where the above features are similar should form a land unit. You should keep the number of land units to a minimum. You must also provide a written description of the key features of each land unit.
                                                                            </p>
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                            )}
                                                        />
                                                    </Col>
                                                </Row>
                                            </CardHeader>
                                            <CardBody>
                                                <Row>
                                                    <Col>
                                                        <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                                            <Row>
                                                                <Col sm="4" style={{ display: "none" }}>
                                                                    <Row>
                                                                        <Col>
                                                                            <Label className="external-map-title">External Map Layers</Label>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col>
                                                                            <Input className="" type="checkbox" checked={gisLayerTopographyDetails.showGISLayer} onChange={handleGISLayerTopographyDetails} name="gisLayerTopographyDetails" id="gisLayerTopographyDetails" />
                                                                            {'   '}<Label className="">Show Topography map Layer</Label>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col>
                                                                            <Input className="" type="checkbox" checked={gisLayerSoilDetails.showGISLayer} onChange={handleGISLayerSoilDetails} name="gisLayerSoilDetails" id="gisLayerSoilDetails" />
                                                                            {'   '}<Label className="">Show Soil map Layer</Label>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col>
                                                                            <Input className="" type="checkbox" checked={gisLayerWetlandDetails.showGISLayer} onChange={handleGISLayerWetlandDetails} name="gisLayerWetlandDetails" id="gisLayerWetlandDetails" />
                                                                            {'   '}<Label className="">Show Wetland map Layer</Label>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col>
                                                                    <Row>
                                                                        <Col>
                                                                            <Label className="fw-bold info-text">LU's are areas of contiguous or non-contiguous land with similar natural and/ or biophysical characteristics. These units are based on the natural and modified biophysical characteristics of the land.
                                                                                Create separate LU's where distinct differences exist in biophysical characteristics e.g., flatland versus rolling hills, or stony soil versus a deep silt.</Label>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <hr />
                                                            { /* Map Functions */}
                                                            <Row className="my-3">
                                                                <Col sm="12" key={uuid()}>
                                                                    <label className="outlineLabel para-light-sm ">Click on the <img className="featureIcon" src="/images/Icons/fwfp-icon-land_units.png" /> then click on the property map and a white cross will appear. Continue to click to identify the points of your Land Unit. Double click when you have finished. You will be able to combine areas of land that share similar characteristics.</label>
                                                                    <br />
                                                                    <Row>
                                                                        {lmu.itemTypes.map(type =>
                                                                            <Col key={uuid()} sm="6" className="style-item-display">
                                                                                <Row>
                                                                                    <Col sm="12">
                                                                                        {type.markerType === "polygon" &&
                                                                                            <>
                                                                                                <img
                                                                                                    className="featureIcon"
                                                                                                    src="/images/Icons/fwfp-icon-land_units.png"
                                                                                                    onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                                                            /> <label className="itemTypeStyle "> Land Units</label>
                                                                                            </>
                                                                                        }
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )}
                                                                        <Col sm="6" style={{ display: "none" }}>
                                                                            <Button className="my-3" style={{ float: "right" }} color="warning" size="sm" onClick={handleClearSelection}>
                                                                                Clear Selection
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>

                                                            {
                                                                blockOnly.islargeEnterprise == true &&
                                                                <Row>
                                                                    <Col sm="8">
                                                                        <Label>LARGE FARM - this farm is “large” - select master LU separately</Label>
                                                                    </Col>
                                                                    <Col sm="4">
                                                                        <FormGroup>
                                                                            {itemsList != undefined && itemsList != null &&
                                                                                <Input type="select" className="float-end" onChange={handleLUSelectChange} name="selectedLMUId" id="selectedLMUId" value={blockOnly.itemId}>
                                                                                    <option value={0} >Entire Farm</option>
                                                                                    {itemsList.filter(lmu => !lmu.isConnectedToAnotherLMU).map(Option =>
                                                                                        <option key={uuid()} value={Option.id}>{Option.name}</option>
                                                                                    )}
                                                                                </Input>
                                                                            }
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            }

                                                            { /* LU Items */}
                                                            <Row key={uuid()} >
                                                                <Col>
                                                                    {
                                                                        blockOnly.isViewBlockOnly == true ?
                                                                            itemsList.filter(selected => selected.id == blockOnly.itemId).map(item =>
                                                                                <LmuItem
                                                                                    key={uuid()}
                                                                                    item={item}
                                                                                    itemTypesList={lmu.itemTypes}
                                                                                    mapDetails={mapDetails}
                                                                                    topographyList={lmu.lookUpList.topographyList}
                                                                                    soilTypePredominantList={lmu.lookUpList.soilTypePredominantList}
                                                                                    soilTypeOtherList={lmu.lookUpList.soilTypeOtherList}
                                                                                    enterpriseTypeList={lmu.lookUpList.enterpriseTypeList}
                                                                                    inherentRisksList={lmu.lookUpList.inherentRisksList}
                                                                                    handleEditItem={handleEditItem}
                                                                                    handleDeleteItem={handleDeleteItem}
                                                                                    itemsList={itemsList}
                                                                                    blockOnly={blockOnly}
                                                                                    hideChildren={hideChildren}
                                                                                    toggleItemState={toggleItemState}
                                                                                    toggleChildItemState={toggleChildItemState}
                                                                                    handleBlockOnlySelect={handleBlockOnlySelect}
                                                                                    handleBlockZoomlevel={handleBlockZoomlevel}
                                                                                    handleCenterPinClick={handleCenterPinClick}
                                                                                    handleBlockZoomlevelSave={handleBlockZoomlevelSave}
                                                                                    handleItemToggle={handleItemToggle}
                                                                                    handleChildItemToggle={handleChildItemToggle}
                                                                                    handleItemHighlight={handleItemHighlight}
                                                                                    handleHideChildrenCheck={handleHideChildrenCheck }
                                                                                />
                                                                            )
                                                                            :
                                                                            itemsList.map(item =>
                                                                                <LmuItem
                                                                                    key={uuid()}
                                                                                    item={item}
                                                                                    itemTypesList={lmu.itemTypes}
                                                                                    mapDetails={mapDetails}
                                                                                    topographyList={lmu.lookUpList.topographyList}
                                                                                    soilTypePredominantList={lmu.lookUpList.soilTypePredominantList}
                                                                                    soilTypeOtherList={lmu.lookUpList.soilTypeOtherList}
                                                                                    enterpriseTypeList={lmu.lookUpList.enterpriseTypeList}
                                                                                    inherentRisksList={lmu.lookUpList.inherentRisksList}
                                                                                    handleEditItem={handleEditItem}
                                                                                    handleDeleteItem={handleDeleteItem}
                                                                                    itemsList={itemsList}
                                                                                    blockOnly={blockOnly}
                                                                                    hideChildren={hideChildren}
                                                                                    toggleItemState={toggleItemState}
                                                                                    toggleChildItemState={toggleChildItemState}
                                                                                    handleBlockOnlySelect={handleBlockOnlySelect}
                                                                                    handleBlockZoomlevel={handleBlockZoomlevel}
                                                                                    handleCenterPinClick={handleCenterPinClick}
                                                                                    handleBlockZoomlevelSave={handleBlockZoomlevelSave}
                                                                                    handleItemToggle={handleItemToggle}
                                                                                    handleChildItemToggle={handleChildItemToggle}
                                                                                    handleItemHighlight={handleItemHighlight}
                                                                                    handleHideChildrenCheck={handleHideChildrenCheck }
                                                                                />
                                                                            )
                                                                    }
                                                                </Col>
                                                            </Row>

                                                            { /* Blocks Summary */}
                                                            <Row>
                                                                <Col sm="12">
                                                                    <h5 className="my-3"> Summary</h5>
                                                                    <Card>
                                                                        <CardBody>
                                                                            <Table bordered>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>
                                                                                            LU Name
                                                                                        </th>
                                                                                        <th>
                                                                                            Size (Ha)
                                                                                        </th>
                                                                                        <th>
                                                                                            Topography  
                                                                                        </th>
                                                                                        <th>
                                                                                            Soil (Predominant)
                                                                                        </th>
                                                                                        <th>
                                                                                            Soil (other)
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        lmuItems != undefined && lmuItems != null && lmuItems.filter(x => x.isConnectedToAnotherLMU == false).map(item =>
                                                                                           
                                                                                                <tr>
                                                                                                    <th scope="row">
                                                                                                        {item.name}
                                                                                                    </th>
                                                                                                    <td>
                                                                                                    {item.totalSize == 0 ? '' : item.totalSize}
                                                                                                    </td>
                                                                                                    <td>{item.lmuItems[0].topographyText == null ? '' : item.lmuItems[0].topographyText} </td>
                                                                                                    <td>{item.lmuItems[0].soilTypePredominantText != null ? item.lmuItems[0].soilTypePredominantText : ''}{(item.lmuItems[0].soilTypePredominantText != null && item.lmuItems[0].soilTypePredominantPercentage != null && item.lmuItems[0].soilTypePredominantPercentage != 0) ? ' (' + item.lmuItems[0].soilTypePredominantPercentage + '%)' : ''}</td>
                                                                                                    <td>{item.lmuItems[0].soilTypeOtherText != null ? item.lmuItems[0].soilTypeOtherText : ''}{(item.lmuItems[0].soilTypeOtherText != null && item.lmuItems[0].soilTypeOtherPercentage != null && item.lmuItems[0].soilTypeOtherPercentage != 0) ? ' (' + item.lmuItems[0].soilTypeOtherPercentage + '%)' : ''}</td>
                                                                                                </tr>
                                                                                        )}
                                                                                    <tr style={{ background:"lightgrey" }}>
                                                                                        <th scope="row">
                                                                                            Total
                                                                                        </th>
                                                                                        <td>
                                                                                            {blockSummary.totalArea.toFixed(1)}
                                                                                        </td>
                                                                                        <td colSpan='3'>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </Table>
                                                                        </CardBody>
                                                                    </Card>
                                                                </Col>
                                                            </Row>

                                                            {/*Document Upload*/}
                                                            {
                                                                sectionObj.isDocumentUploadReq && <Documents refid={sectionObj.id} uploadType="Section" open={false} showArrow={true}></Documents>
                                                            }

                                                            {/*Actions to Consider*/}
                                                            {
                                                                sectionObj.isFarmAPTActionsReq && <ActionsToConsider sectionId={sectionObj.id} />
                                                            }                                                     

                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    
            }

            <Modal backdrop={'static'} keyboard={false} size="lg" isOpen={itemModal.showItemModal} toggle={handleItemModalShowHide} id={itemModal.itemId} className="itemPopup">
                <Form>
                    <ModalHeader
                        toggle={handleItemModalShowHide}>Add/ Edit Land Unit
                    </ModalHeader>

                    <ModalBody>
                        <GeneralDetailForm form={formGeneral} formContiguous={formContiguous} lmuTypesList={lmu.lookUpList.lmuTypesList} isSameAsMaster={formContiguous.isSameAsMaster}
                            handleFormFieldChange={(e) => handleFormFieldChange(e)} />

                        {
                            formDescription.isBiodiversityReq && <BiodiversityForm form={formDescription} hasBiodiversity={hasBiodiversity}
                                handleFormFieldChange={(e) => handleFormFieldChange(e)} />
                        }

                        <NonContiguousForm
                            form={formContiguous} masterLmuList={masterLmuList} isNonContiguous={isNonContiguous}
                        handleFormFieldChange={(e) => handleFormFieldChange(e)} />
                        
                        {formContiguous.isSameAsMaster == false &&
                            <InherentRisks form={formBasicDetail} handleMultiSelectChange={handleMultiSelectInherentRiskChange}></InherentRisks>
                        }
                        {/*<Risk itemPopupRisk= {formRisk}  handleItemPopupRisk={(e) => handleItemPopupRisk(e)} />*/}

                        <AdditionalInformation additionalInfoIsOpen={additionalInfoIsOpen} additionalInfoIsIconUp={additionalInfoIsIconUp}
                            form={formBasicDetail} isSameAsMaster={formContiguous.isSameAsMaster} additionalInfoToggle={additionalInfoToggle}
                            handleFormFieldChange={(e) => handleFormFieldChange(e)} > </AdditionalInformation>

                        <Row>
                            <Col sm="12">
                                <FormGroup check>
                                    <Label
                                        check
                                        for="IsLUDoesNotHaveAnyFarmingOrGrowingActivities"
                                    >
                                        This LU does not have any Farming or Growing activities
                                    </Label>
                                    <Input
                                        id="IsLUDoesNotHaveAnyFarmingOrGrowingActivities"
                                        name="IsLUDoesNotHaveAnyFarmingOrGrowingActivities"
                                        type="checkbox" checked={formEnterpriseDetail.IsLUDoesNotHaveAnyFarmingOrGrowingActivities}
                                        value={formEnterpriseDetail.IsLUDoesNotHaveAnyFarmingOrGrowingActivities}
                                        onChange={(e) => handleIsLUDoesNotHaveAnyFarmingOrGrowingActivitiesChange(e)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        {/*{*/}
                        {/*    !formEnterpriseDetail.IsLUDoesNotHaveAnyFarmingOrGrowingActivities && */}
                        {/*    <>*/}
                        {/*        <EnterpriseDetailForm enterpriseIsOpen={enterpriseIsOpen} enterpriseIsIconUp={enterpriseIsIconUp} enterpriseToggle={enterpriseToggle} form={formEnterpriseDetail}*/}
                        {/*            handleFormFieldChange={(e) => handleFormFieldChange(e)} handleMultiSelectChange={handleMultiEnterpriseTypeChange} />*/}
                        {/*    </>*/}
                        {/*}*/}
                        {!formContiguous.isNonContiguousItem && 
                            /*<Photos key={uuid()} disabledMode={false} refId={itemModal.itemId} header="Photo" uploadType="Item" ></Photos>    */
                            <PhotosWithoutId setImageUploadList={setImageUploadList} imageUploadList={imageUploadList} disabledMode={false} refId={itemModal.itemId} header="Photo" uploadType="Item" ></PhotosWithoutId>
                        }
                        {/*{formContiguous.isSameAsMaster == false &&*/}
                        {/*    <FurtherDetailForm formPastureDrainage={formPastureDrainage} formSoil={formSoil} formStrengths={formStrengths}*/}
                        {/*        isNonContiguous={isNonContiguous} formWeaknesses={formWeaknesses} handleFormFieldChange={(e) => handleFormFieldChange(e)}></FurtherDetailForm>*/}
                        {/*}*/}

                    </ModalBody>

                    <ModalFooter>

                        <div>
                            {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                <>
                            {itemModal.item.nonContiguousItems != undefined && itemModal.item.nonContiguousItems.length > 0 ?
                                    <Button id={itemModal.itemId} color="danger" onClick={handleDeleteItem} size="sm" disabled>
                                        Archive
                                    </Button>
                                    :
                                    <Button id={itemModal.itemId} color="danger" onClick={handleDeleteItem} size="sm">
                                        Archive
                                    </Button>}
                           
                                {' '}
                                {saving ?
                                    <>
                                        <Button onClick={handleItemSave} color="success" disabled size="sm">
                                            <Row>
                                                <Col sm="6">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="6">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row></Button>{' '}
                                    </>
                                    :
                                    <>
                                        <Button onClick={handleItemSave} color="success" size="sm">
                                            Save
                                        </Button>{' '}
                                    </>
                                }
                                </>
                            }
                                <Button color="secondary" onClick={handleItemModalShowHide} size="sm">
                                    Cancel
                                </Button>
                            </div>
                        
                    </ModalFooter>
                </Form>
            </Modal>

            <Modal backdrop={'static'} keyboard={false} size="lg" isOpen={multiItemModal.showMultiItemModal} toggle={handleMultiItemModalShowHide} className="multiItemPopup">
                <Form>
                    <ModalHeader
                        toggle={handleMultiItemModalShowHide}>Combine Land Units
                    </ModalHeader>

                    <ModalBody>
                        <NonContiguousForm
                            form={formContiguous} masterLmuList={masterLmuList} isNonContiguous={isNonContiguous}
                            handleFormFieldChange={(e) => handleFormFieldChange(e)} />
                    </ModalBody>

                    <ModalFooter>

                        <div>
                            {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') && isNonContiguous == true &&
                                <>
                                    {saving ?
                                        <>
                                        <Button onClick={handleMultiItemSave} color="success" disabled size="sm">
                                                <Row>
                                                    <Col sm="6">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="6">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row></Button>{' '}
                                        </>
                                        :
                                        <>
                                        <Button onClick={handleMultiItemSave} color="success" size="sm">
                                                Save
                                            </Button>{' '}
                                        </>
                                    }
                                </>
                            }
                            <Button color="secondary" onClick={handleMultiItemModalShowHide} size="sm">
                                Cancel
                            </Button>
                        </div>

                    </ModalFooter>
                </Form>
            </Modal>

            <Modal isOpen={itemDeleteModal.showModal} toggle={handleItemDeleteModalShowHide} id={itemDeleteModal.itemId}>
                <ModalHeader toggle={handleItemDeleteModalClose}>Archive Item</ModalHeader>
                <ModalBody>
                    Do you want to Archive this item?
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleDeleteItemConfirm}>Yes</Button>
                    <Button color="secondary" onClick={handleItemDeleteModalClose}>No</Button>
                </ModalFooter>
            </Modal>

            <Modal size="lg" isOpen={blockOnly.showCenterPinPopup} backdrop={false} className="centerPinPopup">
                <Form>
                    <ModalHeader toggle={handleCenterPinPopupClose} >Add/Edit Block Centre</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Name</Label>
                                    <Input type="text" name="txtShapeName" id="txtShapeName" value={blockOnly.name} readOnly disabled />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>GPS Location : </Label><Label id="lblOutlineloaction">{blockOnly.coordinates}</Label>
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        {blockOnly.actionType != "Add New" ? <Button color="danger" onClick={handleCenterPinDelete} size="sm">Delete</Button> : ''}
                        <Button color="success" onClick={handleCenterPinSave} size="sm">Save</Button>
                        <Button color="primary" onClick={handleCenterPinPopupClose} size="sm">Cancel</Button>

                    </ModalFooter>
                </Form>
            </Modal>

            {actionModal.showActionPopup &&
                <Action redirectPage="/lmu"
                    handleActionClose={handleActionClose}
                    itemTypeId={actionModal.itemTypeId}
                    sectionName={lmu.section}
                    sectionId={lmu.itemTypes[0].sectionId}
                    itemId={actionModal.itemId}
                    itemName={actionModal.itemName}
                    showActionPopupModal={actionModal.showActionPopup}
                    actionId={actionModal.actionId}
                    itemTypeSelect={lmu.itemTypes}
                    itemTypeDisabled={true}>
                </Action>
            }

        </div >
    );
}

export default Lmu;